export const INDIA_USER_ROLE = 'INDIA_USER';
